module.exports = __webpack_public_path__ + "img/store-allocation.d6beebfb.png";